import { curry, cond, stubTrue, tap, identity } from 'lodash/fp';
/**
 * Used for functional side effects with predefined condition. It does not
 * modify the result.
 *
 * @param {Function} predicate - Predicate used to determine of the effect
 * should be executed or not.
 * @param {Function} effectFunc - Function to be executed when the
 * predicate is met.
 *
 * @example
 * map(func, collection)
 * tapWhen(isNumber, (value) => {
 *   console.log(value)
 * })
 */

export default curry(function (predicate, effectFunc) {
  return cond([[predicate, tap(effectFunc)], [stubTrue, identity]]);
});